/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 10b70efd47036b72e8d1dec5d12405f81f712e3a
 */

export type ContentProductListOutAvailability = typeof ContentProductListOutAvailability[keyof typeof ContentProductListOutAvailability] | null;


export const ContentProductListOutAvailability = {
  available: 'available',
  upcoming: 'upcoming',
  expired: 'expired',
} as const;
